import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=1b51454c&scoped=true&lang=pug&"
import script from "./SocialMedia.vue?vue&type=script&lang=ts&"
export * from "./SocialMedia.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=1b51454c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51454c",
  null
  
)

export default component.exports